import { Factories, Form } from "../types";
import { toCamelCase, withoutPrefix } from "../utils";

export const factories: Partial<Factories> = {
  title: (value: Form["title"]) => value,
  formContent: (value: Form["formContent"]) => {
    return Object.keys(value).reduce((formContent, key) => {
      const property = withoutPrefix(key, "form");
      return Object.assign(formContent, { [toCamelCase(property)]: value[key] });
    }, {});
  },
  formFieldOptions: (value: Form["formFieldOptions"]) => {
    return value.formFieldOptions?.reduce((formFieldOptions, formFieldOption) => {
      const option = Object.keys(formFieldOption).reduce((content, key) => {
        const property = withoutPrefix(key, "input", "dropdownOption");
        return Object.assign(content, { [toCamelCase(property)]: formFieldOption[key] });
      }, {});

      const identifier = toCamelCase(formFieldOption.inputIdentifier);
      const options = formFieldOptions[identifier] ?? [];
      return Object.assign(formFieldOptions, { [identifier]: options.concat(option) });
    }, {});
  },
  formFields: (value: Form["formFields"]) => {
    return value.formFieldContent?.reduce((formFieldContent, formField) => {
      const content = Object.keys(formField).reduce((field, key) => {
        const property = withoutPrefix(key, "input");
        return Object.assign(field, { [toCamelCase(property)]: formField[key] });
      }, {});

      const identifier = toCamelCase(formField.inputIdentifier);
      return Object.assign(formFieldContent, { [identifier]: content });
    }, {});
  },
  formSections: (value: Form["formSections"]) => {
    return value.formSection?.reduce((formSection, section) => {
      const content = Object.keys(section).reduce((field, key) => {
        const property = withoutPrefix(key, "section");
        return Object.assign(field, { [toCamelCase(property)]: section[key] });
      }, {});

      const identifier = toCamelCase(section.sectionIdentifier);
      return Object.assign(formSection, { [identifier]: content });
    }, {});
  }
};
